// leaf-town - input: keyboard, gamepad and the action state the scenes poll (split out of core.js; the touch pad in index.html feeds G.input.touch)
(function () {
  'use strict';
  const G = window.G;

  const KEYMAP = {
    ArrowLeft: 'left', KeyA: 'left',
    ArrowRight: 'right', KeyD: 'right',
    ArrowUp: 'up', KeyW: 'up',
    ArrowDown: 'down', KeyS: 'down',
    Space: 'jump', KeyZ: 'jump', KeyK: 'jump',
    KeyX: 'attack', KeyJ: 'attack',
    KeyC: 'dash', ShiftLeft: 'dash', ShiftRight: 'dash', KeyL: 'dash',
    KeyV: 'special', KeyE: 'special', KeyI: 'special',
    Enter: 'start', Escape: 'pause', KeyP: 'pause',
  };
  const ACTIONS = ['left', 'right', 'up', 'down', 'jump', 'attack', 'dash', 'special', 'start', 'pause'];
  const held = {}, queued = {}, prev = {};
  const input = (G.input = { down: {}, pressed: {}, released: {}, any: false, padActive: false, locked: false });
  ACTIONS.forEach((a) => { held[a] = 0; input.down[a] = input.pressed[a] = input.released[a] = false; });
  let anyQueued = false;

  window.addEventListener('keydown', (e) => {
    const a = KEYMAP[e.code];
    if (G.audio) G.audio.unlock();
    if (e.metaKey || e.ctrlKey) return;
    if (e.target && e.target.tagName === 'INPUT') return;                 // typing a name is not a game key
    if (G.keyGuard && G.keyGuard(e)) return;                              // an overlay (the shared screen view) swallowed this key
    if (a) {
      e.preventDefault();
      if (!e.repeat) { held[a]++; queued[a] = true; anyQueued = true; held['_' + e.code] = a; }
    } else if (!e.repeat && e.code !== 'Tab') anyQueued = true;
    if (e.code === 'KeyF' && !e.repeat) G.toggleFullscreen && G.toggleFullscreen();
    if (e.code === 'KeyM' && !e.repeat && G.audio) G.audio.toggleMute();
  });
  window.addEventListener('keyup', (e) => {
    const a = KEYMAP[e.code];
    if (a && held['_' + e.code]) { held[a] = Math.max(0, held[a] - 1); held['_' + e.code] = null; }
  });
  window.addEventListener('blur', () => { ACTIONS.forEach((a) => (held[a] = 0)); for (const k in held) if (k[0] === '_') held[k] = null; });
  window.addEventListener('pointerdown', () => { if (G.audio) G.audio.unlock(); anyQueued = true; });

  function pollPad(state) {
    const pads = navigator.getGamepads ? navigator.getGamepads() : [];
    for (const p of pads) {
      if (!p || !p.connected) continue;
      const b = (i) => p.buttons[i] && p.buttons[i].pressed;
      const ax = p.axes[0] || 0, ay = p.axes[1] || 0;
      const s = {
        left: b(14) || ax < -0.4, right: b(15) || ax > 0.4, up: b(12) || ay < -0.55, down: b(13) || ay > 0.55,
        jump: b(0), attack: b(2), dash: b(1) || b(5) || b(7), special: b(3) || b(4), start: b(9), pause: b(8),
      };
      for (const a of ACTIONS) if (s[a]) { state[a] = true; input.padActive = true; }
      break;
    }
  }
  // called once per fixed update
  input.poll = () => {
    const state = {};
    for (const a of ACTIONS) state[a] = held[a] > 0 || !!queued[a];
    pollPad(state);
    if (input.script) for (const a of ACTIONS) if (input.script[a]) state[a] = true;   // test harness
    if (input.touch) for (const a of ACTIONS) if (input.touch[a]) state[a] = true;     // on-screen buttons
    input.any = anyQueued;
    for (const a of ACTIONS) {
      const d = state[a] && !input.locked;
      input.pressed[a] = d && !prev[a];
      input.released[a] = !d && !!prev[a];
      input.down[a] = d;
      prev[a] = d;
      if (input.pressed[a]) input.any = true;
      queued[a] = false;
    }
    anyQueued = false;
    // menu helpers: confirm/back on any of the usual keys
    input.ok = input.pressed.start || input.pressed.jump || input.pressed.attack;
    input.back = input.pressed.pause || input.pressed.dash;
  };
  input.clear = () => { for (const a of ACTIONS) { input.pressed[a] = input.released[a] = false; } input.ok = input.back = input.any = false; };

})();
